import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { ContainedButton, AutoTable } from 'secondstep-components'

export const LicenseUnassignedContainedButton = styled(ContainedButton)`
  width: 162px;
  &:not([disabled]):hover {
    background: ${themeGet('colors.buttonHover')};
    border-color: ${themeGet('colors.buttonHover')};
  }
`
export const UnassignedLicensesTable = styled(AutoTable)`
  color: ${themeGet('colors.darkGray')};
  border: none;
  background-color: white;
  margin-top: 1rem;

  tbody tr td {
    border-bottom: 1px solid ${themeGet('colors.gray400')};
    line-height: 24px;
  }

  [class*='AutoTableHeader'] {
    font-weight: bold;
    width: auto;
  }

  [class*='AutoTableHeader'],
  .child:first-child {
    width: 100%;
  }

  [class*='AutoTableHeaderContent'] div {
    width: 15px;
    height: 5px;
    padding-top: 0;
  }

  [class*='AutoTableHeaderTh'] {
    border-bottom: 1px solid ${themeGet('colors.gray400')};
    padding: 0 0.9rem;
    ${themeGet('breakpoints.mobile')} {
      padding-left: ${themeGet('spacing.blue16_1rem')};
      padding-right: ${themeGet('spacing.blue16_1rem')};
    }
    background-color: ${themeGet('colors.beaconGray')};
  }

  [class*='AutoTableHeaderTh']:last-child,
  [class*='Cell']:last-child {
    padding-right: 40px;
  }

  [class*='AutoTableHeaderSpan'] {
    margin-right: ${themeGet('spacing.pink8_0_5rem')};
    padding: 0;
  }
`
